import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { isFuture, parseISO } from "date-fns"

import Notification from "@ui-kit/atoms/notification"
import { useLocalStorage } from "../../utils/custom-hooks"

export default (props) => {
  const {
    announcements: { nodes: announcements },
  } = useStaticQuery(query)

  const unexpired = announcements.filter((announcement) => {
    if (announcement.expires) {
      return isFuture(parseISO(announcement.expires))
    }
    return true // if no expiration date set
  })

  return (
    <React.Fragment>
      {unexpired &&
        announcements.map((announcement, i) => (
          <Notification
            {...announcement}
            key={i}
            useLocalStorage={useLocalStorage}
          />
        ))}
    </React.Fragment>
  )
}

const query = graphql`
  query {
    announcements: allNodeAnnouncement(
      limit: 1
      sort: { created: DESC }
      filter: { drupal_internal__nid: { ne: 323 } }
    ) {
      nodes {
        nid: drupal_internal__nid
        title
        body {
          html: processed
        }
        expires: field_issue_date(formatString: "Y-MM-DD")
      }
    }
  }
`
